import { TipusVehiclesEditorComponent } from './../../components/tipus-vehicles-editor/tipus-vehicles-editor.component';
import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { TipusVehiclesTableComponent } from '../../components/tipus-vehicles-table/tipus-vehicles-table.component';
import { TipusVehiclesFilter } from '../../models/tipus-vehicles-filter';
import { TipusVehiclesFilterComponent } from '../../components/tipus-vehicles-filter/tipus-vehicles-filter.component';

@Component({
  selector: 'app-tipus-vehicles',
  templateUrl: './tipus-vehicles.component.html',
  styleUrls: ['./tipus-vehicles.component.scss']
})
export class TipusVehiclesComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: TipusVehiclesFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(TipusVehiclesTableComponent) tipusVehiclesTable: TipusVehiclesTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<TipusVehiclesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new TipusVehiclesFilter('id', 'desc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit() {
    this.auth.UserCanSeePage(this.auth.Pages.TipusVehicles);
    this.tipusVehiclesTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.tipusVehiclesTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Tipus Vehicles'));
    }
  }

  edit() {
    const idSeleccionat: string = this.tipusVehiclesTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(TipusVehiclesEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.tipusVehiclesTable.load(); }
    });
  }

  refresh() {
    this.tipusVehiclesTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(TipusVehiclesFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.tipusVehiclesTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: TipusVehiclesFilter) => {
      this.tipusVehiclesTable.filter.set(filter);
      this.tipusVehiclesTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.tipusVehiclesTable.generateExcel();
  }

}
